import {CellItem} from './cellItem'
import {ValidateResult} from '../contentType'
import {Questionary} from '../questionary'
import {XmlTagInfo} from "../xmlTagProvider";
import {checkboxItemView} from "../../ui/items/checkbox";
import {CheckboxGroup} from "../groups/checkboxGroup";
import {Form} from "../form/form";
import Cell from "../form/cell";
import {Vnode} from "mithril";

export class CheckboxItem extends CellItem {

	globalUnknown: boolean;
	localUnknown: boolean;

	static fromXml(config: XmlTagInfo){
		return new CheckboxItem(config);
	}

	private constructor(config: XmlTagInfo){
		super(config);
		this.globalUnknown = config.attributes['globalUnknown'] === "yes";
		this.localUnknown = config.attributes['localUnknown'] === "yes";
	}

	init(questionary: Questionary, form: Form, cell: Cell){
		super.init(questionary, form, cell);

		this.active = () => this.getVariable();

		if(this.globalUnknown) {
			this.validate = ValidateResult.okResult;
		}

	}

	getView():Vnode {
		return checkboxItemView(this);
	}

	onNavigatedTo(){
		// set initial value
		if(!this.getVariable()){
			this.reset();
		}
	}

	validate () : ValidateResult {
		return this.getGroup().validate();
	}

	protected updateUnknowns (){

		if(this.globalUnknown) { // Jsem já checkbox globalUnknown (GU)?
			if(this.getVariable()) { // Ano jsem, hurá! A jsem zaškrtlý?
				this.form.activeGlobalUnknown = this; // Muy bueno!!! Takže se pěkne vecpu do nastavení formu, že já jsem ten pravý GU
				this.form.reset(); // A vyresetuju formulář, což znamená, že já, protože jsem formulářový GU, zůstanu zaškrtnutý.
			} else if (this.form.activeGlobalUnknown === this) { // Hmmm, jsem právě odškrtnutý GU
				this.form.activeGlobalUnknown = null; // A zárovveň jsem přišel o supa dupe VIP místo GUa ve formuláři, ergo formulář je úplně prázdný.
			}
		} else { // nejsem GU
            super.updateUnknowns();
        }
	}

	// expect binded cellitem (this nemusí být this)
	set() {
		if (this.cell.enabled){
			this.setVariable(!this.getVariable());

            this.updateUnknowns();

			this.form.reValidate();
		}
	}


	reset() {
		if(this.form.activeGlobalUnknown !== this){
            this.setVariable(0);
		}
	}

	isEmpty() {
		return this.globalUnknown ? true : super.isEmpty();
	}

	resourcesToPreload(): string[] {
		return this.getSimpleContentResources(this.childrenTags);
	}


	private getGroup() : CheckboxGroup {
		return <CheckboxGroup> this.group;
	}
}